import React from "react"
import BriefcaseImage from "./BriefcaseImage"
import BriefcaseInput from "./BriefcaseInput"

function Briefcase(props) {
    return (
        <div>
            <BriefcaseImage />
            <BriefcaseInput callBackOverlay={props.callBackOverlay} callBackStatus={props.callBackStatus}/>
        </div>
    )
}

export default Briefcase